/* eslint-disable no-restricted-imports */
import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Text,
} from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';

type DeleteModelDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  modelName: string;
  isLoading: boolean;
};

export const DeleteModelDialog: React.FC<DeleteModelDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  modelName,
  isLoading,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader
            fontFamily="marketingPage"
            fontWeight="bold"
            fontSize="lg"
            color="text.title">
            Delete Model
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              Are you sure you want to delete <strong>{modelName}</strong>? This
              action cannot be undone.
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button
              ref={cancelRef}
              onClick={onClose}
              buttonName="cancel-delete"
              variant="ghost">
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              isLoading={isLoading}
              buttonName="confirm-delete"
              sx={{
                bg: 'background.red.500',
                color: 'white',
                _hover: { bg: 'red.600' },
              }}>
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
